export const CLAIM_WORKFLOW_ACTIONS = {
  EDIT: 'EDIT',
  REVOKE: 'REVOKE',
  SUBMIT_RCA: 'SUBMIT_RCA',
  VALIDATE_RCA: 'VALIDATE_RCA',
  VERIFY_CLAIM: 'VERIFY_CLAIM',
  REJECT_CLAIM: 'REJECT_CLAIM',
  APPROVE_CLAIM: 'APPROVE_CLAIM',
  ACKNOWLEDGE: 'ACKNOWLEDGE',
  REASSIGN: 'REASSIGN',
  ROLE_ACTION: 'ROLE_ACTION',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  REWORK: 'REWORK',
  SEND_FOR_ACK: 'SEND_FOR_ACK',
  SEND_TO_CLIENT: 'SEND_TO_CLIENT',
  SEND_TO_FINANCE: 'SEND_TO_FINANCE',
  SEND_TO_OPS_HOD: 'SEND_TO_OPS_HOD',
  SEND_TO_SALES_HOD: 'SEND_TO_SALES_HOD',
  SEND_TO_HOD: 'SEND_TO_HOD'
};
